import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
  DyscalculiaConfigMode,
  DyscalculiaCustomConfiguration,
} from "types/testTypes";
import {
  CATEGORY_VERSION_MAP,
  FEATURE_VERSION_MAP,
  TEST_TYPE_VERSION_MAP,
} from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
} from "../configurationHelperConstants";
import { virtualAssistanceDyscalculiaConfig } from "@constants/virtualAssistanceConstants";
import { VIRTUAL_ASSISTANT_LANGUAGE_LIST } from "@constants/languageConstants";

export const availableDyscalculiaTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      {
        value: TestType.NumericalCognition,
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.NumericalCognition],
      },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.Dyscalculia],
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
  },
  testSpeedOptions: null,
  languageOptions: null,
  virtualAssistantOptions: {
    configurationFieldName: "virtualAssistanceConfig",
    validSinceVersion: FEATURE_VERSION_MAP["minVirtualAssistant"],
    choices: VIRTUAL_ASSISTANT_LANGUAGE_LIST,
  },
  testSpecificConfigurationOptions: {
    ...DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
    dyscalculiaConfigModes: {
      validSinceVersion: null,
      choices: [
        {
          validSinceVersion: null,
          value: DyscalculiaConfigMode.Adult,
        },
        {
          validSinceVersion: null,
          value: DyscalculiaConfigMode.Child,
        },
        {
          validSinceVersion: null,
          value: DyscalculiaConfigMode.AdultAdaptive,
        },
        {
          validSinceVersion: null,
          value: DyscalculiaConfigMode.AdultAdaptiveFast,
        },
      ],
      configurationFieldName: "dyscalculiaConfigMode",
    },
  },
};

export const dyscalculiaTestConfiguration: TestConfiguration = {
  name: TestCategory.Dyscalculia,
  testType: TestType.NumericalCognition,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: false,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceDyscalculiaConfig,
  isPressToStartEnabled: false,
  extraData: {
    dyscalculiaConfigMode: DyscalculiaConfigMode.Child,
  } as DyscalculiaCustomConfiguration,
};

export const dyscalculiaUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: null,
};
